class ApiClient {
  constructor() {
    this.baseURL = process.env.REACT_APP_API_BASE_URL;
    console.log('ApiClient initialized with baseURL:', this.baseURL);
  }

  getHeaders(customHeaders = {}) {
    const token = localStorage.getItem('access_token');
    
    const headers = {
      'Content-Type': 'application/json',
      ...customHeaders,
    };

    if (customHeaders['Content-Type'] === null) {
      delete headers['Content-Type'];
    }

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn('No access token found in localStorage');
    }

    return headers;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const headers = this.getHeaders(options.headers);

    const config = {
      ...options,
      headers,
      credentials: 'omit', // Don't send cookies since we're using bearer token
    };

    const response = await fetch(url, config);

    if (!response.ok) {
      const error = new Error(response.statusText);
      error.response = response;
      
      // Try to parse error response body
      try {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorText = await response.text();
          error.response.data = errorText ? JSON.parse(errorText) : null;
        } else {
          const errorText = await response.text();
          error.response.data = errorText || null;
        }
      } catch (parseError) {
        error.response.data = null;
      }
      
      throw error;
    }

    // Check if there's content to parse
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      const text = await response.text();
      return text ? JSON.parse(text) : null;
    }
    
    // Return null for empty responses (like 204 No Content)
    return null;
  }

  async get(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'GET' });
  }

  async post(endpoint, data, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async put(endpoint, data, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  async patch(endpoint, data, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  }

  async delete(endpoint, options = {}) {
    return this.request(endpoint, { method: 'DELETE', headers: { 'Content-Type': null }, ...options });
  }
}

// Export a singleton instance
export const apiClient = new ApiClient(); 